import {gql} from '@apollo/client';

export const matcherNotificationOverviewQuery = gql`
    query MatcherNotificationOverviewQuery($dimensions: [MatcherDimension], $filters: [MatcherSearchFilter], $sort: [MatcherSort], $limit: Int, $offset: Int) {
        matcherNotificationOverview(dimensions: $dimensions, filters: $filters, sort: $sort, limit: $limit, offset: $offset)
    }  
`;